import { link } from "fs";

export const multiCenterData = [
    {
        slug: 'amalfi-coast',
        type: 'Charter Itinerary',
        image: '/assets/images/multi-center/Amalfi-Coast.jpg',
        alt: 'Tailand holiday',
        title: 'Exploring the hotspots of the Amalfi Coast',
        description: `Home to charming villages and well-loved sights, the Amalfi Coast remains a favourite year-round — and for good reason. With breathtaking views, rich history, and no shortage of limoncello, a yacht charter here promises an unforgettable escape along one of Italy’s most iconic coastlines.`,
        url: '/itinerary/amalfi-coast',
        location: 'Amalfi Coast',
        breadcrumbs: [
            {
                label: 'Italy',
                link: '',
            },
            {
                label: 'Amalfi Coast',
                link: '',
            },
        ],
        heroText: 'Explore the Amalfi Coast in style',
        content: {
            title: 'Amalfi Coast',
            content: ' The Amalfi Coast is a stunning stretch of coastline in southern Italy, known for its picturesque villages, dramatic cliffs, and crystal-clear waters. It is a UNESCO World Heritage site and is famous for its charming towns such as Positano, Amalfi, and Ravello. The region offers breathtaking views, delicious cuisine, and a rich cultural heritage, making it a popular destination for travelers seeking both relaxation and adventure.',
        },
        inineraryData: [
            {
                id: 1,
                duration: 'DAY 1',
                title: 'Naples & Ischia',
                image: '/assets/images/itinerary/amalfi/day1.jpg',
                link: '/itinerary/amalfi-coast/naples-ischia',
                textContent: `Start your charter in Naples, taking time to explore local culture before sailing to Ischia, known for its natural beauty and relaxed pace.`,
            },
            {
                id: 2,
                duration: 'DAY 2',
                title: 'Ischia',
                image: '/assets/images/itinerary/amalfi/day2.jpg',
                link: '/itinerary/amalfi-coast/ischia',
                textContent: (`Spend a full day enjoying Ischia’s thermal waters and scenic walks, or visit quiet coastal villages and peaceful beaches.`),
            },
            {
                id: 3,
                duration: 'DAY 3 ',
                title: 'Ventotene & Ponza',
                image: '/assets/images/itinerary/amalfi/day3.jpg',
                link: '/itinerary/amalfi-coast/ventotene-ponza',
                textContent: (`Cruise to Ventotene for snorkeling or diving, then head to Ponza to explore rugged coastlines and quiet bays.`),
            },
            {
                id: 4,
                duration: 'DAY 4',
                title: 'Ponza',
                image: '/assets/images/itinerary/amalfi/day4.jpg',
                link: '/itinerary/amalfi-coast/ponza',
                textContent: (
                    `Relax on Ponza’s beaches, visit its botanical gardens, or try local cuisine before setting off toward Capri in the evening.`
                ),
            },
            {
                id: 5,
                duration: 'DAY 5',
                title: 'Capri',
                image: '/assets/images/itinerary/amalfi/day5.jpg',
                link: '/itinerary/amalfi-coast/capri',
                textContent: (
                    `Spend the day visiting Capri’s well-known landmarks like the Blue Grotto or enjoy a casual stroll through town and seaside cafes.`
                ),
            },
            {
                id: 6,
                duration: 'DAY 6',
                title: 'Salerno & Amalfi',
                image: '/assets/images/itinerary/amalfi/day6.jpg',
                link: '/itinerary/amalfi-coast/salerno-amalfi',
                textContent: (
                    `Explore the historic town of Salerno and its cathedral, then move on to Amalfi and nearby Ravello for coastal views and garden walks.`
                ),
            },
            {
                id: 7,
                duration: 'DAY 7',
                title: 'Positano & Sorrento',
                image: '/assets/images/itinerary/amalfi/day7.jpg',
                link: '/itinerary/amalfi-coast/positano-sorrento',
                textContent: (
                    `Visit Positano for sightseeing or watersports, then enjoy the evening in Sorrento’s lively harbor and old town.`
                ),
            },
            {
                id: 8,
                duration: 'DAY 8',
                title: 'Pompeii & Naples',
                image: '/assets/images/itinerary/amalfi/day8.jpg',
                link: '/itinerary/amalfi-coast/naples-pompeii',
                textContent: (
                    `Disembark in Naples with an optional morning visit to Pompeii or a final scenic cruise near the ruins of Baiae.`
                ),
            },
        ]
    },
    {
        slug: 'windward-islands',
        type: 'Charter Itinerary',
        image: '/assets/images/multi-center/winward.jpg',
        alt: 'Idyllic Windward Islands',
        title: 'Idyllic Windward Islands',
        description: `
                Brimming with emerald rainforests, tranquil hidden coves, and stylish beachside retreats, a yacht charter through the Windward Islands offers one of the most refined getaways in the Caribbean. With dramatic mountain landscapes, powder-soft beaches and crystal-clear waters, this enchanting island chain delivers boundless adventure and effortless luxury in equal measure.`,
        url: '/itinerary/windward-islands',
        location: 'Windward Islands',
        breadcrumbs: [
            {
                label: 'Caribbean',
                link: '',
            },
            {
                label: 'Windward Islands',
                link: '',
            },
        ],
        heroText: 'Explore the Windward Islands in style',
        content: {
            title: 'Windward Islands',
            content: ' The Windward Islands are a group of islands in the Caribbean, known for their stunning natural beauty, vibrant culture, and warm hospitality. This chain of islands includes popular destinations like St. Lucia, Martinique, and Grenada. The Windward Islands offer a mix of lush rainforests, pristine beaches, and charming towns, making them a paradise for nature lovers and adventure seekers alike.',
        },
        inineraryData: [
            {
                id: 1,
                duration: 'DAY 1',
                title: 'Antigua',
                image: '/assets/images/itinerary/windward-islands/antigua.jpg',
                link: '/itinerary/windward-islands/antigua',
                textContent: `Embark at Jolly Harbor and cruise to Guadeloupe. Enjoy snorkeling, lush rainforests, and mountain views before heading toward Martinique.`,
            },
            {
                id: 2,
                duration: 'DAY 2',
                title: 'Martinique',
                image: '/assets/images/itinerary/windward-islands/martinique.jpg',
                link: '/itinerary/windward-islands/martinique',
                textContent: `Start with a champagne breakfast. Explore rainforests, waterfalls, and beaches like Anse Dufour for hiking or relaxing in nature.`,
            },
            {
                id: 3,
                duration: 'DAY 3',
                title: 'St Lucia',
                image: '/assets/images/itinerary/windward-islands/st-lucia.jpg',
                link: '/itinerary/windward-islands/st-lucia',
                textContent: `Enjoy views of Mount Gimie and the iconic Pitons. Snorkel in the marine park, then dine onboard under the stars.`,
            },
            {
                id: 4,
                duration: 'DAY 4',
                title: 'Bequia',
                image: '/assets/images/itinerary/windward-islands/bequia.jpg',
                link: '/itinerary/windward-islands/bequia',
                textContent: `Relax on Princess Margaret Beach, swim in calm waters, and dine at local spots like Firefly or Bagatelle for Caribbean cuisine.`,
            },
            {
                id: 5,
                duration: 'DAY 5',
                title: 'Mustique',
                image: '/assets/images/itinerary/windward-islands/mustique.jpg',
                link: '/itinerary/windward-islands/mustique',
                textContent: `Enjoy water sports and visit Macaroni Beach. Later, dine at Basil's Bar, known for its sunset views and lively ambiance.`,
            },
            {
                id: 6,
                duration: 'DAY 6',
                title: 'Canouan',
                image: '/assets/images/itinerary/windward-islands/canouan.jpg',
                link: '/itinerary/windward-islands/canouan',
                textContent: `Explore Sandy Lane Yacht Club, play golf, or relax at Canouan Estate spa. End the day with dinner at Bellini's Bar or La Varenne.`,
            },
            {
                id: 7,
                duration: 'DAY 7',
                title: 'Mayreau',
                image: '/assets/images/itinerary/windward-islands/mayreau.jpg',
                link: '/itinerary/windward-islands/mayreau',
                textContent: `Visit Salt Whistle Bay for snorkeling, kitesurfing, and diving at Mayreau Gardens. Eat at the popular Combination Cafe.`,
            },
            {
                id: 8,
                duration: 'DAY 8',
                title: 'Tobago Cays',
                image: '/assets/images/itinerary/windward-islands/tobago-cays.jpg',
                link: '/itinerary/windward-islands/tobago-cays',
                textContent: `Snorkel in the protected marine park. Enjoy scenic views and white beaches across the uninhabited cays like Jamesby and Baradal.`,
            },
            {
                id: 9,
                duration: 'DAY 9',
                title: 'Carriacou',
                image: '/assets/images/itinerary/windward-islands/carriacou.jpg',
                link: '/itinerary/windward-islands/carriacou',
                textContent: `Try paddleboarding or waterskiing at Reef Island. Visit Sandy Island for a beach BBQ, and explore Carriacou’s museum and local crafts.`,
            },
            {
                id: 10,
                duration: 'DAY 10',
                title: 'Grenada',
                image: '/assets/images/itinerary/windward-islands/grenada.jpg',
                link: '/itinerary/windward-islands/grenada',
                textContent: `Relax on Grenada’s beaches or try local spicy cuisine. If time allows, dine at Rhodes Restaurant at the Calabash Hotel before departure.`,
            },
        ],
    },
    {
        slug: 'island-hopping-cyclades-saronic',
        type: 'Charter Itinerary',
        image: '/assets/images/multi-center/Hopping.jpg',
        alt: 'Island Hopping: Cyclades & Saronic',
        title: 'Island Hopping: Cyclades & Saronic',
        description: `Among the most stunning island groups in the Mediterranean, the Cyclades boast brilliant blue skies, sparkling turquoise seas, iconic whitewashed houses cascading down rugged cliffs, blue-domed chapels, ancient sites, and an abundance of natural beauty. From world-famous yachting destinations like Santorini and Mykonos to secluded, lesser-known gems, this collection of over 200 islands offers something for every kind of traveller. During your 10-day yacht charter through the spectacular Aegean, expect to uncover charming villages, lively nightlife, peaceful coves, breathtaking sunsets and some of the finest seafood in Greece.`,
        url: '/itinerary/island-hopping-cyclades-saronic',
        location: 'Cyclades & Saronic',
        breadcrumbs: [
            {
                label: 'Greece',
                link: '/locations/greece',
            },
            {
                label: 'Cyclades & Saronic',
                link: '',
            },
        ],
        heroText: 'Explore the Cyclades & Saronic in style',
        content: {
            title: 'Cyclades & Saronic',
            content: ' The Cyclades & Saronic Islands are a group of islands in the Aegean Sea, known for their stunning landscapes, crystal-clear waters, and charming villages. The Cyclades include popular islands like Santorini, Mykonos, and Paros, while the Saronic Islands are closer to Athens and include Hydra, Poros, and Aegina. These islands offer a mix of vibrant nightlife, beautiful beaches, rich history, and traditional Greek culture, making them a popular destination for travelers seeking both relaxation and adventure.',
        },
        inineraryData: [
            {
                id: 1,
                duration: 'DAY 1',
                title: 'Athens to Syros',
                image: '/assets/images/itinerary/island-hopping/syros.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/athens-syros',
                textContent: `Embark in Athens, cruise to Kolona Bay (Kithnos) for swimming and lunch, then continue to Ermoupoli, Syros for dinner and overnight.`,
            },
            {
                id: 2,
                duration: 'DAY 2',
                title: 'Syros – Delos – Rinia – Mykonos',
                image: '/assets/images/itinerary/island-hopping/mykonos.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/syros-mykonos',
                textContent: `Visit ancient ruins on Delos, swim and relax at Rinia, then head to Mykonos for gourmet dining and nightlife in Psarou Bay.`,
            },
            {
                id: 3,
                duration: 'DAY 3',
                title: 'Mykonos – Paros',
                image: '/assets/images/itinerary/island-hopping/paros.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/mykonos-paros',
                textContent: `Cruise to Naousa, Paros. Choose from swimming, shopping, or dining in local tavernas. Optional excursions to Naxos landmarks.`,
            },
            {
                id: 4,
                duration: 'DAY 4',
                title: 'Paros – Ios – Santorini',
                image: '/assets/images/itinerary/island-hopping/santorini.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/paros-santorini',
                textContent: `Spend the day at Manganari Beach on Ios or visit Santo Wines. In the evening, anchor in Santorini and explore Akrotiri ruins.`,
            },
            {
                id: 5,
                duration: 'DAY 5',
                title: 'Santorini – Milos',
                image: '/assets/images/itinerary/island-hopping/milos.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/santorini-milos',
                textContent: `Explore Kleftiko beach and caves on Milos. Cruise to Adamantas for dinner and drinks in local bars and restaurants.`,
            },
            {
                id: 6,
                duration: 'DAY 6',
                title: 'Milos – Polyaigos – Folegandros',
                image: '/assets/images/itinerary/island-hopping/folegandros.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/milos-folegandros',
                textContent: `Swim and relax at Polyaigos, then cruise to Folegandros for evening walks, traditional meals, and cliffside views.`,
            },
            {
                id: 7,
                duration: 'DAY 7',
                title: 'Folegandros – Monemvasia',
                image: '/assets/images/itinerary/island-hopping/monemvasia.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/folegandros-monemvasia',
                textContent: `Cruise to Kiparissi beach near Monemvasia. Spend the day in nature, relaxing, exploring villages, or enjoying watersports.`,
            },
            {
                id: 8,
                duration: 'DAY 8',
                title: 'Monemvasia – Spetses',
                image: '/assets/images/itinerary/island-hopping/spetses.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/monemvasia-spetses',
                textContent: `Swim in Zogeria Bay, then explore Spetses in the evening. Enjoy the island’s architecture, beaches, and maybe a horse buggy ride.`,
            },
            {
                id: 9,
                duration: 'DAY 9',
                title: 'Spetses – Dokos – Hydra',
                image: '/assets/images/itinerary/island-hopping/hydra.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/spetses-hydra',
                textContent: `Morning at Dokos Bay, then head to Hydra for a quiet evening. Explore car-free streets, shop, and enjoy a seaside picnic.`,
            },
            {
                id: 10,
                duration: 'DAY 10',
                title: 'Hydra – Athens',
                image: '/assets/images/itinerary/island-hopping/athens.jpg',
                link: '/itinerary/island-hopping-cyclades-saronic/hydra-athens',
                textContent: `Final cruise to Athens with a swim stop on the way. Disembark at Floisvos Marina and optionally visit city landmarks like the Parthenon.`,
            },
        ],
    },
];